module.exports = __webpack_public_path__ + "img/board-3.abb04adc.png";